module.exports = function getVariable(key) {

    const hostname = `${window.location.hostname}`;
    let env;
    if (hostname.indexOf('dev') > -1 || hostname.indexOf('pobd') >-1 || hostname.indexOf('pobt') >-1) {
        env = "dev";
    } else if (hostname.indexOf('hmg') > -1 || hostname.indexOf('pobh') >-1) {
        env = "stage";
    } else {
        env = "prod";
    }
    const config = {
        local: {
            linkAreaCliente: 'http://localhost:8080/atendimento/area-do-cliente',
        },
        dev: {
            linkAreaCliente: 'https://pobt.prudentialdobrasil.com.br/atendimento/area-do-cliente',
        },
        stage: {
            linkAreaCliente: 'https://pobh.prudentialdobrasil.com.br/atendimento/area-do-cliente',
        },
        prod: {
            linkAreaCliente: 'https://www.prudentialdobrasil.com.br/atendimento/area-do-cliente',
        },
    };
    if (env) {
        if (!config[env]) {
            return null;
        }
        return config[env][key];
    }
    return config.common[key];
};
